
import { useState, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";

import Sidebar from "./Sidebar";
import Topbar from "./Topbar";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function Layout() {

    const location = useLocation();

    const fullScreenRoutes = [
        "/bank-statement",
        "/reports",
        "/ledger",
        "/summary",
        "/ledger-details"
    ];

    const isFullScreen = fullScreenRoutes.includes(
        location.pathname.replace(/\/$/, "") || "/"
    );

    const [sidebarOpen, setSidebarOpen] = useState(!isFullScreen);

    useEffect(() => {
        setSidebarOpen(!isFullScreen);
    }, [location.pathname, isFullScreen]);

    const toggleSidebar = () => {
        setSidebarOpen(prev => !prev);
    };

    return (

        <div className="app-layout">

            {/* Fixed Sidebar */}
            {sidebarOpen && (
                <aside className="sidebar-fixed">
                    <Sidebar />
                </aside>
            )}

            {/* Main Application Area */}
            <div
                className={`main-content ${
                    sidebarOpen ? "sidebar-visible" : "sidebar-hidden"
                }`}
            >

                {/* Fixed Topbar */}
                <header className="topbar-fixed">
                    <Topbar
                        toggleSidebar={toggleSidebar}
                        sidebarOpen={sidebarOpen}
                    />
                </header>

                {/* Independently Scrollable Content */}
                <main
                    className="content-scroll"
                    key={location.pathname}
                    tabIndex={0}
                >
                    <div className="container-fluid py-2">

                        <Outlet />

                    </div>
                </main>

            </div>

            <ToastContainer
                position="top-right"
                autoClose={3000}
                theme="colored"
            />

        </div>
    );
}

export default Layout;
